import type { AuthState } from './types'

export const selectAuthUser = (state: { auth: AuthState }) => state.auth.user
export const selectAuthLoading = (state: { auth: AuthState }) => state.auth.loading
export const selectsSeenPopups = (state: { auth: AuthState }) => state.auth.seenPopups
